








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class Comment extends Vue {
    @Prop()
    color?: string;

    @Prop()
    text?: string;

    get getClass() {
        switch (this.color) {
            case 'blue':
                return 'pa-2 ma-2 text-justify caption commentCardBlue';
            case 'green':
                return 'pa-2 ma-2 text-justify caption commentCardGreen';
            case 'yellow':
                return 'pa-2 ma-2 text-justify caption commentCardYellow';
            case 'orange':
                return 'pa-2 ma-2 text-justify caption commentCardOrange';
            case 'purple':
                return 'pa-2 ma-2 text-justify caption commentCardPurple';
            default:
                return 'pa-2 ma-2 text-justify caption';
        }
    }
}
